<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'ORGANIZATION.MY_ORGANIZTIONS' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm btn-add-org" routerLink="/organizations/create"
                        *ngIf="permissionAccess.check('ORGANIZATION_CREATE')">
                        <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                    </button>
                </div>
            </div>
            <div class="card-body card-body_table">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="num">№</th>
                            <th scope="col" class="bin">{{ 'ORGANIZATION.BIN' | translate }}/{{ 'ORGANIZATION.TIN' |
                                translate }}</th>
                            <th scope="col" class="name">{{ 'NAME' | translate }}</th>
                            <th scope="col" class="eds">{{ 'ORGANIZATION.CONFIRMED_EDS' | translate }}</th>
                            <th scope="col" class="products">{{ 'PRODUCT.PRODUCTS' | translate }}</th>
                            <th scope="col" class="status">{{ 'STATUS' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="organizations.length > 0">
                        <tr *ngFor="let organization of organizations; let i = index">
                            <td class="num">{{ getRowNumber(i) }}</td>
                            <td class="bin">
                                <a routerLink="/organizations/profile/{{ organization.id }}">{{ organization.ident_num
                                    }}</a>
                            </td>
                            <td class="name">{{ organization.name }}</td>
                            <td class="eds">
                                <span *ngIf="signed">{{ 'YES' | translate }}</span>
                                <span *ngIf="!signed">{{ 'NO' | translate }}</span>
                            </td>
                            <td class="products">{{ organization.number_of_products | mask: 'separator': ' ' }}</td>
                            <td class="status">
                                <div class="state" [class.moderation]="organization.state.id == 'MODERATION'"
                                    [class.active]="organization.state.id == 'ACTIVE'"
                                    [class.draft]="organization.state.id == 'DRAFT'"
                                    [class.blocked]="organization.state.id == 'BLOCKED'">
                                    {{ organization.state.name }}
                                </div>
                            </td>
                            <td class="action">
                                <button type="button" class="btn btn-none show-profile"
                                    routerLink="/organizations/profile/{{ organization.id }}" placement="top"
                                    ngbTooltip="{{ 'WATCH' | translate }}" tooltipClass="clue-name"
                                    *ngIf="permissionAccess.check('ORGANIZATION_PROFILE')">
                                    <!-- <i class="bi bi-eye"></i> -->
                                    <svg-icon class="" src="/assets/images/icons/eye.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                </button>
                                <button type="button" class="btn btn-none show-profile"
                                    routerLink="/organizations/edit/{{ organization.id }}" placement="top"
                                    ngbTooltip="{{ 'EDIT' | translate }}" tooltipClass="clue-name"
                                    *ngIf="permissionAccess.check('ORGANIZATION_EDIT')">
                                    <!-- <i class="bi bi-pencil-square"></i> -->
                                    <svg-icon class="" src="/assets/images/icons/edit.svg" [stretch]="true"
                                        [svgStyle]="{'width.px':18, 'height.px':18}"></svg-icon>
                                </button>
                                <!-- <button type="button" class="btn btn-light" (click)="onConfirm([organization.id])" placement="top" ngbTooltip="{{ 'DELETE' | translate }}" *ngIf="permissionAccess.check('ORGANIZATION_DELETE')">
                                    <i class="bi bi bi-trash"></i>
                                </button> -->
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="organizations.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="7">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="7">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </div>

    </div>

    <div class="col-12">
        <div class="card-footer-pagination">
            <div class="pagination-component">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>